export const filterMenuList = (dataRoute, apiRoute) => {
  return dataRoute
    .map((menuItem) =>
      filterMenu(
        menuItem,
        apiRoute.find((menuItemData) => menuItemData.code === menuItem.code)
      )
    )
    .filter((filteredMenuItem) => filteredMenuItem !== null);
};

function filterMenu(menuItem, correspondingMenuFromAPI) {
  if (
    !correspondingMenuFromAPI?.action_page?.find((e) => e.code === "Read")
      .is_active
  ) {
    return null;
  }

  return {
    ...menuItem,
  };
}
